import { Button, Paper, Stack, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { type Lead, useSetLastContact, useTakeLead } from '@/models/leads';

type Props = {
  lead: Lead;
  canQualify: boolean;
  onQualify: () => void;
};

export function ActionsCard({ lead, canQualify, onQualify }: Props) {
  const markContacted = useSetLastContact();
  const take = useTakeLead();
  const canTake = lead.status === 'New Lead' || lead.archivedAt != null;
  const qualified = lead.sqlStatus === 'Qualified';

  return (
    <Paper withBorder p="sm">
      <Stack gap="xs">
        {canTake && (
          <Button
            size="xs"
            color="pink"
            loading={take.isPending}
            onClick={() =>
              take.mutate(
                { leadId: lead.id },
                {
                  onError: (e) =>
                    notifications.show({ color: 'red', message: String(e) }),
                },
              )
            }
          >
            Take
          </Button>
        )}
        {canQualify && !qualified && (
          <Button size="xs" color="blue" onClick={onQualify}>
            Qualify
          </Button>
        )}
        <Button
          size="xs"
          variant="default"
          loading={markContacted.isPending}
          onClick={() => markContacted.mutate({ leadId: lead.id })}
        >
          Mark contacted now
        </Button>
        <Text size="xs" c="dimmed">
          Last contact:{' '}
          {lead.lastContactAt
            ? new Date(lead.lastContactAt).toLocaleString()
            : 'Never'}
        </Text>
        {lead.nextTaskAt && (
          <Text size="xs" c="dimmed">
            Next task: {new Date(lead.nextTaskAt).toLocaleDateString()}
          </Text>
        )}
      </Stack>
    </Paper>
  );
}
